import Authentication from '@api/services/Authentication';
import { DashboardProduct } from '@api/store/products/types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDashboards, LoadProductList } from '../../../store/products/actions';

export const useActivePlan = (): DashboardProduct => {
    const [firstDashboard] = useSelector(getDashboards);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!firstDashboard && Authentication.isAuthenticated()) {
            dispatch(LoadProductList());
        }
    }, []);

    const isPlan = !firstDashboard?.IsAddon;

    return (isPlan && firstDashboard) || ({ ActivePlanDetails: {} } as DashboardProduct);
};
